// extracted by mini-css-extract-plugin
module.exports = {"Submit":"IM_hPtm6","btnBuy":"__73JnTn_s","notify":"vkJcZEwr","disable":"__6J95HJvk"};